import { Component } from '@angular/core';

@Component({
  template: 'Healthy',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class HealthComponent {}
